<div class="p-6">
  <div class="mb-6">
    <h2 class="mb-4 text-lg font-semibold text-gray-800">Your Accessible Syllabuses</h2>
    @if (state.accessibleSyllabuses.length > 0) {
      <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        @for (syllabus of state.accessibleSyllabuses; track syllabus.id) {
          <a
            [routerLink]="getSyllabusRoute(syllabus)"
            class="group block rounded-lg border border-gray-200 p-4 transition-colors hover:border-sky-300 hover:bg-sky-50"
          >
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="font-semibold text-gray-900 group-hover:text-sky-700">
                  {{ syllabus.name }}
                </h3>
                <div class="mt-2 flex items-center text-xs text-gray-400">
                  @if (syllabus.program.icon) {
                    <dojo-icon [icon]="syllabus.program.icon" [size]="12" class="mr-1" />
                  }
                  <span>{{ syllabus.program.full_name || syllabus.program.short_name }}</span>
                </div>
              </div>

              <dojo-icon
                [icon]="'arrow-right'"
                [size]="16"
                class="text-gray-400 transition-colors group-hover:text-sky-500"
              />
            </div>
          </a>
        }
      </div>
    } @else {
      <div class="rounded-lg border border-gray-200 p-6 text-center">
        <dojo-icon [icon]="'exclamation-circle'" [size]="24" class="mx-auto mb-2 text-gray-400" />
        <p class="text-gray-600">No accessible syllabuses found.</p>
        <p class="text-sm text-gray-500">Please contact support if you believe this is an error.</p>
      </div>
    }
  </div>
</div>
